"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISimulationManifestEntrySerializedSchema = exports.SimulationContentTypeSchema = exports.SimulationContentType = exports.ISpiceSimulationArtifactSchema = void 0;
const zod_1 = require("zod");
const INetStats_1 = require("../CircuitStates/INetStats");
const ISimulationStrategy_1 = require("./ISimulationStrategy");
const ProjectModelNetStats_1 = require("../DesignModels/ProjectModelNetStats");
const SpiceSimulationFailureMode_1 = require("./SpiceSimulationFailureMode");
const SerializedModeState_1 = require("../CircuitStates/SerializedModeState");
exports.ISpiceSimulationArtifactSchema = zod_1.default.object({
    spiceCircuit: zod_1.default.string().optional(),
    allStd: zod_1.default.string().optional(),
    circuitState: zod_1.default.record(zod_1.default.string(), SerializedModeState_1.SerializedModeStateSchema).optional(),
    strategy: zod_1.default.lazy(() => ISimulationStrategy_1.ISimulationStrategySchema).optional(),
    failureMode: zod_1.default.nativeEnum(SpiceSimulationFailureMode_1.SpiceSimulationFailureMode).optional(),
    score: zod_1.default.number().optional(),
    error: zod_1.default
        .object({
        name: zod_1.default.string(),
        message: zod_1.default.string(),
        stack: zod_1.default.string().optional(),
    })
        .transform((e) => {
        const result = new Error(e.message);
        Object.assign(e, result);
        return result;
    })
        .optional(),
    analysisOpts: zod_1.default.record(zod_1.default.string(), zod_1.default.any()).optional(),
    netStats: zod_1.default.lazy(() => ProjectModelNetStats_1.ProjectModelNetStatsSchema).optional(),
    durationMS: zod_1.default.number().optional(),
});
var SimulationContentType;
(function (SimulationContentType) {
    SimulationContentType["SpiceOperatingPointAnalysisOutput"] = "SpiceOperatingPointAnalysisOutput";
    SimulationContentType["SpiceTransientAnalysisOutput"] = "SpiceTransientAnalysisOutput";
    SimulationContentType["BoundaryAnalysisOutput"] = "BoundaryAnalysisOutput";
    SimulationContentType["SpiceError"] = "SpiceError";
})(SimulationContentType || (exports.SimulationContentType = SimulationContentType = {}));
exports.SimulationContentTypeSchema = zod_1.default.nativeEnum(SimulationContentType);
exports.ISimulationManifestEntrySerializedSchema = zod_1.default.object({
    resultId: zod_1.default.string(),
    type: exports.SimulationContentTypeSchema,
    netStats: zod_1.default
        .record(zod_1.default.string(), zod_1.default.lazy(() => INetStats_1.INetStatsSchema))
        .optional(),
});
//# sourceMappingURL=ISimulationManifestEntry.js.map